import axios from 'axios';
import {
  GET_COMPANY,
  COMPANY_LOADING,
  CLEAR_CURRENT_COMPANY,
  GET_ERRORS,
  GET_COMPANIES,
  GET_COMPANY_ITEM,
  CLEAR_COMPANY_ITEM,
  CLEAR_ERRORS,
  GET_COMPANY_FOR_REVIEW,
  PUBLISH_COMPANY,
  EMAIL_COMPANY_SENT
} from './types';
//import { logoutUser } from '../actions/authActions';

// Get current company
export const getCurrentCompany = () => (dispatch) => {
  dispatch(setCompanyLoading());
  axios
    .get('/api/companies')
    .then((res) =>
      dispatch({
        type: GET_COMPANY,
        payload: res.data,
      })
    )
    .catch((err) =>
      dispatch({
        type: GET_COMPANY,
        payload: {},
      })
    );
};

// Get companies for review
export const getCompaniesForReview = () => (dispatch) => {
  dispatch(setCompanyLoading());
  axios
    .get('/api/companies/review')
    .then((res) =>
      dispatch({
        type: GET_COMPANY_FOR_REVIEW,
        payload: res.data,
      })
    )
    .catch((err) =>
      dispatch({
        type: GET_COMPANY_FOR_REVIEW,
        payload: {},
      })
    );
};

// Publish company
export const publishCompany = (company_id) => (dispatch) => {
  axios
    .get(`/api/companies/review/${company_id}`)
    .then((res) =>
      dispatch({
        type: PUBLISH_COMPANY,
        payload: company_id,
      })
    )
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      })
    );
};

// Create company
export const createCompany = (companyData, history) => (dispatch) => {
  axios
    .post('/api/companies', companyData)
    .then((res) => history.push('/dashboard'))
    .catch((err) => {
      dispatch(clearErrors());
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      });
    });
};

// Edit company
export const editCompany = (companyData, company_id, history, isAdmin) => (
  dispatch
) => {
  axios
    .post(`/api/companies/${company_id}`, companyData)
    .then((res) => {
      if (companyData.get('isreviewed') === 'false' && isAdmin) {
        history.push('/review');
      } else {
        history.push('/dashboard');
      }
    })
    .catch((err) => {
      dispatch(clearErrors());
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      });
    });
};

// Get all companies
export const getCompanies = () => (dispatch) => {
  dispatch(setCompanyLoading());
  axios
    .get('/api/companies/all')
    .then((res) =>
      dispatch({
        type: GET_COMPANIES,
        payload: res.data,
      })
    )
    .catch((err) =>
      dispatch({
        type: GET_COMPANIES,
        payload: null,
      })
    );
};

// Get company by ID
export const getCompanyByID = (id) => (dispatch) => {
  dispatch(clearErrors());
  dispatch(setCompanyLoading());
  axios
    .get(`/api/companies/${id}`)
    .then((res) =>
      dispatch({
        type: GET_COMPANY_ITEM,
        payload: res.data,
      })
    )
    .catch((err) =>
      dispatch({
        type: GET_COMPANY_ITEM,
        payload: null,
      })
    );
};

// Delete company by ID
export const deleteCompanyByID = (company_id, history) => (dispatch) => {
  dispatch(clearErrors());
  axios
    .delete(`/api/companies/${company_id}`)
    .then((res) => history.push('/dashboard'))
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      })
    );
};

// Send Email Request to Company
export const emailRequest = (userData) => (dispatch) => {
  axios
    .post('api/companies/email/request', userData)
    .then((res) => {
      dispatch(clearErrors());
      dispatch({
        type: EMAIL_COMPANY_SENT,
        payload: res.data,
      });
    })
    .catch((err) => {
      dispatch(clearErrors());
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      });
    });
};

// Search on home page
export const search = (searchData, history) => (dispatch) => {
  axios
    .post('api/companies/utils/search', searchData)
    .then((res) => {
      history.push(`/${res.data.success}?search=${encodeURIComponent(searchData.search)}`)
      console.log(res.data)
    })
    .catch((err) => {
      dispatch(clearErrors());
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      });
    });
};

// Company loading
export const setCompanyLoading = () => {
  return {
    type: COMPANY_LOADING,
  };
};

// Clear "company" & clear loading
export const clearCurrentCompany = () => {
  return {
    type: CLEAR_CURRENT_COMPANY,
  };
};

// Clear "company_item" & clear loading
export const clearCompanyItem = () => {
  return {
    type: CLEAR_COMPANY_ITEM,
  };
};

// Clear errors
export const clearErrors = () => {
  return {
    type: CLEAR_ERRORS,
  };
};
